import { createModel } from '@rematch/core';
import URL from '../../constants/api-constants';
import createBaseMetaFieldsModel from './utils/createBaseMetaFieldsModel';
import { RootModel } from '.';
import { generatePath } from 'react-router-dom';
import http from '../http/http-common';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { BaseApi } from '../http/base-api.service';
import { toast } from 'react-toastify';

const apiService = new BaseApi();
const baseMetaFieldsModel = createBaseMetaFieldsModel(URL.REPORT_META_FIELDS);

const headers: AxiosRequestConfig['headers'] = apiService.getApiVersionHeader();

export const report_meta_fields = createModel<RootModel>()({
  ...baseMetaFieldsModel,
  effects: () => ({
    ...baseMetaFieldsModel.effects!(),

    async saveMetaFieldsAsDefault(id: string) {
      try {
        const path = generatePath(URL.REPORT_META_FIELDS_KEEP_DEFAULT, { id });
        const response = await http.patch(path, {}, { headers });
        toast.success('Meta fields updated successfully');

        return response.data;
      } catch (error: unknown) {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.message || 'An unexpected error occurred');
        } else if (error instanceof Error) {
          toast.error(error.message);
        } else {
          toast.error('An unexpected error occurred');
        }
        throw error;
      }
    },

    async loadDefaultMetaFields(id: string) {
      try {
        const path = generatePath(URL.REPORT_META_FIELDS_LOAD_DEFAULT, { id });
        const response = await http.patch(path, {}, { headers });
        toast.success('Meta fields updated successfully');

        return response.data;
      } catch (error: unknown) {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.message || 'An unexpected error occurred');
        } else if (error instanceof Error) {
          toast.error(error.message);
        } else {
          toast.error('An unexpected error occurred');
        }
        throw error;
      }
    },
  }),
});
